import { defaultDialogSetupBuilder } from '@/components/services/dialog/dialogSetup';

export default (invokeArgs = {}) => {
  const postfix = invokeArgs.amount > 1 ? 's' : '';
  const dialogSubject = `order${postfix}`;

  defaultDialogSetupBuilder(
    {
      isModalShown: true,
      confirmTitle: `Complete the ${dialogSubject}`,
      confirmText: `Are you sure you want to complete
 <strong>${invokeArgs.amount}</strong> ${dialogSubject}? This action cannot be undone.`,
      confirmBtnColor: 'invokedDialogGreen',
      confirmBtnText: `Complete ${dialogSubject} (${invokeArgs.amount})`,
      ...invokeArgs,
    },
  );
};
